import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TreeServices from "../../services/Tree.services";
import { checkIfhasSetToDisplayOnly, getCountryCode, getModuleName } from "../../utils/oneintelligence/OneIntelligenceHelper";
import { deepMergeObjects, isObjAllUndefined } from "../../utils/MainHelper";
import WorkerServices from "../../services/Worker.services";
import ConfigServices from "../../services/Config.services";

function useCategoryAnalysisTree(visible, analysisObj) {
    const [isLoading, setisLoading] = useState(true);
    const [treeData, settreeData] = useState([]);
    const [checkedKeys, setcheckedKeys] = useState([]);
    const [percentage, setPercentage] = useState(0)

    const { checkedBehavioralSegments } = useSelector((state) => state.reports);
    const {
        setup: {
            marketPackage
        }
    } = useSelector((state) => state.buildTargets);

    const percentageCallBack = (percent) => {
        setPercentage(percent)
    }
    useEffect(() => {
        if (visible && analysisObj) {
            setisLoading(true);
            const countryCode = getCountryCode("enterprise");
            const marketPackageCode = marketPackage.code.replace("dev", "");

            const folderLockConfigSpecificModule = analysisObj?.lockFolder?.[marketPackageCode];
            const folderLockConfigAllModule = analysisObj?.lockFolder?.allmodule;
            const moduleConfig = deepMergeObjects(folderLockConfigAllModule || {}, folderLockConfigSpecificModule || {});
            let folderLockConfig = {
                allcountry: moduleConfig?.allcountry,
                current: moduleConfig?.[countryCode]
            }

            folderLockConfig = isObjAllUndefined(folderLockConfig)

            TreeServices.getAudienceTree(false, analysisObj, percentageCallBack).then(async (response) => {
                let treeList = response;
                let folder = analysisObj?.folderName;

                if (analysisObj?.folderNameObj?.[marketPackageCode]) {
                    folder = analysisObj?.folderNameObj?.[marketPackageCode];
                };

                if (folder) {
                    const find = response.find((child) => child && (child.name === folder));
                    if (find) {
                        treeList = [...(find.children || find.tempChildren)]
                    }
                } else {
                    if (["insights", "hcp_insights", "veterinaryinsights", "hcp_attributes", "hcp_marketscan", "expertmedia"].includes(marketPackageCode) || ["hcpmarketscan", "hcpattributes"].includes(analysisObj.key)) {
                        let find = null
                        if (analysisObj.key === "hcpattributes") {
                            find = response.find((child) => child && child.name === ("HCP Attributes"));
                        } else {
                            find = response.find((child) => child && child.name === ("Knowledge Base"));
                        }
                        if (find) {
                            treeList = [...(find.children || find.tempChildren)]
                        }
                    }
                }

                if (!folderLockConfig) {
                    const folderLockConfigFromSavant = await ConfigServices.getFolderLockConfig({ module: getModuleName(), marketExplorerCode: analysisObj?.code || analysisObj?.key });
                    folderLockConfig = isObjAllUndefined(folderLockConfigFromSavant)
                }
                if (folderLockConfig) {
                    WorkerServices.lockFolderBaseFromConfig([treeList, folderLockConfig]).then(async (lockedFolder) => {
                        const filtered = await checkIfhasSetToDisplayOnly(lockedFolder, "audienceTree", analysisObj)
                        settreeData(filtered);
                        setisLoading(false);
                    });
                } else {
                    const filtered = await checkIfhasSetToDisplayOnly(treeList, "audienceTree", analysisObj)
                    settreeData(filtered);
                    setisLoading(false);
                }
            }).then(() => {
                setcheckedKeys([]);
                // if (checkedBehavioralSegments.length) {
                //     setcheckedKeys(checkedBehavioralSegments);
                // } else {
                //     setcheckedKeys([]);
                // }
            });
        }
    }, [visible, analysisObj, marketPackage, checkedBehavioralSegments.length]);

    return {
        isLoading,
        percentage,
        treeData,
        checkedKeys,
        setcheckedKeys
    };
}

export default useCategoryAnalysisTree;
